import { Button, Stack, Typography } from '@mui/material';
import { PlusIcon } from '@schooly/style';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { ModalEmpty } from '../../../../../components/uikit-components/Modal/ModalEmpty';

export const SchoolTuneSubjectsEmptyStub: FC = () => {
  return (
    <Stack sx={{ height: '100%' }}>
      <Typography variant="h2" mb={2.5}>
        <FormattedMessage id="school-tabs-Subjects" />
      </Typography>

      <ModalEmpty width="300px">
        <Typography variant="h3" color={(theme) => theme.palette.common.grey2}>
          <FormattedMessage id="school-tabs-Subjects-EmptyMessage" />
        </Typography>
        <Link to="subjects">
          <Button startIcon={<PlusIcon />}>
            <FormattedMessage id="school-tabs-Subjects-AddSubjects" />
          </Button>
        </Link>
      </ModalEmpty>
    </Stack>
  );
};
